'use es6';

import { Set as ImmutableSet } from 'immutable';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import toJS from 'transmute/toJS';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import virtualizedMenuRenderer from 'UIComponents/input/utils/virtualizedMenuRenderer';
import { getEventValue } from '../../../utils/jsEventUtils';
import { useUserOptions } from '../../../data/hooks/useUserOptions';
import { jsx as _jsx } from "react/jsx-runtime";
const MINIMUM_SEARCH_COUNT = 3;
const valuePropDefault = ImmutableSet();
const EmailRecipientSelect = ({
  onChange,
  value = valuePropDefault
}) => {
  const {
    data: recipients
  } = useUserOptions();
  const handleChange = useCallback(event => {
    const newSelection = ImmutableSet(getEventValue(event));
    onChange(newSelection);
  }, [onChange]);
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailInternalRecipientSelectLabel"
    }),
    required: true,
    children: /*#__PURE__*/_jsx(UISelect, {
      anchorType: "button",
      "data-test-id": "email-report-recipients-select",
      options: toJS(recipients),
      onChange: handleChange,
      value: toJS(value),
      multi: true,
      minimumSearchCount: MINIMUM_SEARCH_COUNT,
      placeholder: "",
      menuRenderer: virtualizedMenuRenderer
    })
  });
};
EmailRecipientSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.instanceOf(ImmutableSet).isRequired
};
export default EmailRecipientSelect;